import {showToast} from '@chekinapp/ui';
import {FastAPIServiceError} from '@chekin/core';
import {useGuestAccountTokenMutation} from 'hooks/auth/useGuestAccountTokenMutation';
import {useAuth} from 'hooks/auth/useAuth';
import {useAuthErrorMessage} from 'hooks/auth/useAuthErrorMessage';

type Props = {
  onSuccess?: () => void;
  onInvalid?: () => void;
  onError?: (error: FastAPIServiceError) => void;
};
export function useSignIn({onSuccess, onError, onInvalid}: Props) {
  const getErrorMessage = useAuthErrorMessage();
  const {authenticate} = useAuth();

  const {mutate: signIn, isPending} = useGuestAccountTokenMutation({
    onSuccess: async data => {
      authenticate({token: data.access_token});
      onSuccess?.();
    },
    onError: error => {
      if (error.detail === 'Invalid credentials') {
        onInvalid?.();
      } else {
        showToast.error(getErrorMessage(error, 'auth.sign_in_error'));
        onError?.(error);
      }
    },
  });

  return {signIn, isPending};
}
